import { Stack, Typography } from "@mui/material";
import Iconify from "src/components/Iconify";

type Props = {
	title: string;
	isColapsed: boolean;
	onClick: VoidFunction;
};

export default function TitlteColapse({ isColapsed, onClick, title }: Props) {
	return (
		<Stack flexDirection={"row"} alignItems={"center"} gap={1.5} onClick={onClick}>
			<Typography variant='h6' sx={{ mb: 0, cursor: "pointer" }}>
				{title}
			</Typography>
			<Iconify
				icon={`iconamoon:arrow-${!isColapsed ? "up" : "down"}-2-duotone`}
				width={22}
				sx={{ cursor: "pointer", mt: 0.4 }}
			/>
		</Stack>
	);
}
